import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { MapDispatchToProps, MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { ISitesAndTenantsInfo } from '~src/siteManagement/serverApi/types/ISitesAndTenantsInfo';
import {Sites} from '~src/siteManagement/services/resources/Sites';
import {SpacesSiteUrls} from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { learnMoreStyle,SettingsStyles } from '../styles/CommonStyles';
import { fetchPrivateConnectionsRequest } from './actions/FetchPrivateConnectionsRequestAction';
import { ConnectedPrivateConnectionTable } from './components/PrivateConnectionTable';
import { privateConnectSettingsContainer, privateConnectSpaceContainer } from './styles/PrivateConnectSettingsStyles';


interface PrivateConnectSiteSettingsSubspaceOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionServerAdmin: boolean;
  readonly isOnlineEnvironment: boolean;
}

export interface PrivateConnectSiteSettingsSubspaceStateProps {
  readonly currentSiteName: string;
  readonly currentSiteUrlName: string;
  readonly sitesAndTenantsInfo: ISitesAndTenantsInfo;
}

export interface PrivateConnectSiteSettingsSubspaceDispatchProps {
  requestPrivateConnectionsInfo: (server: SessionManagementService) => void;
}

export type PrivateConnectSiteSettingsSubspaceProps = PrivateConnectSiteSettingsSubspaceOwnProps & PrivateConnectSiteSettingsSubspaceStateProps & PrivateConnectSiteSettingsSubspaceDispatchProps;

export interface PrivateConnectSiteSettingsSubspaceState {
  isLoading: boolean;
  readonly hasError: boolean;
}

export class PrivateConnectSiteSettingsSubspaceComponent extends React.PureComponent<PrivateConnectSiteSettingsSubspaceProps, PrivateConnectSiteSettingsSubspaceState> {
  private unmounted: boolean = false;
  private sites = Sites.instance;


  private initialState: PrivateConnectSiteSettingsSubspaceState = {
    isLoading: true,
    hasError: false
  };


  public constructor(props: PrivateConnectSiteSettingsSubspaceProps) {
    super(props);
    this.state = this.initialState;
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidMount(): void {
    if (this.props.isOnlineEnvironment) {
      this.props.requestPrivateConnectionsInfo(this.props.server);
    }
  }

  public render() {
    if (!this.props.isOnlineEnvironment) {
      return null;
    }

    return (
      <div className={privateConnectSpaceContainer}>
        <div className={privateConnectSettingsContainer}>
          <div className={SettingsStyles.settingsGroupName}>
            {Messages.privateconnect()}
          </div>
          <div style={{width: '700px'}}>
            {Messages.privateConnect_description_label()}
            &nbsp;
            <TextLinkWidget
              testId={'private-connect-learn-more'}
              target={'_blank'}
              href={HelpService.getHelpUrlByCategory('online-settings-private-connect')}
              className={learnMoreStyle}>
              {Messages.learnMore()}
            </TextLinkWidget>
          </div>
        </div>
        <div className={privateConnectSettingsContainer}>
          <ConnectedPrivateConnectionTable server={this.props.server} />
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<PrivateConnectSiteSettingsSubspaceStateProps> = (state: AppState) => ({
  currentSiteName: SessionSiteSelectors.siteName(state),
  currentSiteUrlName: SessionSiteSelectors.siteUrlName(state),
  sitesAndTenantsInfo: state.sitesAndTenantsInfo
});

const mapDispatchToProps: MapDispatchToProps<PrivateConnectSiteSettingsSubspaceDispatchProps> =
  (dispatch) => bindActionCreators({
    requestPrivateConnectionsInfo: fetchPrivateConnectionsRequest
  },
  dispatch);

export const PrivateConnectSiteSettingsSubspace: React.ComponentClass<PrivateConnectSiteSettingsSubspaceOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(PrivateConnectSiteSettingsSubspaceComponent);